module.exports = __webpack_public_path__ + "img/back_icon.eeb5198d.svg";